/* ============================================================
   XSIVA ID COMMUNITY — Theme behaviour
   Vanilla JS port of the prototype interactions, wired to
   Shopify's AJAX Cart + Predictive Search APIs.
   Everything uses event delegation so section re-renders
   (cart drawer, theme editor) keep working.
   ============================================================ */
(function () {
  'use strict';

  var XSIVA = (window.XSIVA = window.XSIVA || {});
  var routes = (window.Shopify && window.Shopify.routes) || { root: '/' };
  var ROOT = routes.root || '/';
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* -------------------------------------------------- utils */
  function on(type, selector, handler, opts) {
    document.addEventListener(type, function (e) {
      var el = e.target.closest ? e.target.closest(selector) : null;
      if (el) handler(e, el);
    }, opts || false);
  }
  var lastTrigger = null;
  function focusables(el) {
    return $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return !n.closest('[hidden]') && (n.offsetWidth || n.offsetHeight || n.getClientRects().length); });
  }
  function openOverlay(el) {
    if (!el) return;
    lastTrigger = document.activeElement;
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');            // expose the (now visible) dialog to assistive tech
    document.documentElement.style.overflow = 'hidden';
    var dlg = el.querySelector('[role="dialog"]') || el;
    if (dlg === el && !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    var target = focusables(dlg)[0] || dlg;
    setTimeout(function () { try { target.focus(); } catch (e) {} }, 30);   // move focus into the dialog
  }
  function closeOverlay(el) {
    if (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); }
    if (!$('.is-open.xs-overlay, .xs-fit.is-open')) {
      document.documentElement.style.overflow = '';
    }
    if (lastTrigger && lastTrigger.focus) { try { lastTrigger.focus(); } catch (e) {} }   // restore focus to opener
    lastTrigger = null;
  }
  function showToast(msg, isError) {
    var t = $('#xs-toast');
    if (!t) { t = document.createElement('div'); t.id = 'xs-toast'; t.className = 'xs-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.toggle('xs-toast--error', !!isError);
    t.classList.add('is-on');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }
  XSIVA.toast = showToast;
  XSIVA.openOverlay = openOverlay;
  XSIVA.closeOverlay = closeOverlay;

  /* ==================================================================
     SLIDESHOWS (hero + campaign) — auto-advance, arrows, progress segs
     ================================================================== */
  function initSlideshows() {
    $$('[data-slideshow]').forEach(function (root) {
      if (root._ss) return;
      var slides = $$('[data-slide]', root);
      var segs = $$('[data-slide-seg]', root);
      if (!slides.length) return;
      root._ss = true;
      slides.forEach(function (s) { s.hidden = false; }); // crossfade uses opacity, not display:none
      root.classList.add('xs-ss-ready');
      var idx = 0, timer, dur = parseInt(root.getAttribute('data-interval') || '4800', 10);
      function show(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-shown', k === idx);
          if (k !== idx) { Array.prototype.forEach.call(s.querySelectorAll('video'), function (v) { try { v.pause(); } catch (e) {} }); }
        });
        segs.forEach(function (s, k) { s.classList.toggle('is-past', k < idx); s.classList.toggle('is-active', k === idx); });
        // play the VISIBLE video in the active slide (supports separate desktop/mobile videos), pause the rest
        Array.prototype.forEach.call(slides[idx].querySelectorAll('video'), function (v) {
          var visible = !RM && (v.offsetWidth || v.offsetHeight || v.getClientRects().length);
          if (visible) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { try { v.pause(); } catch (e) {} }
        });
      }
      function next() { show(idx + 1); reset(); }
      function reset() { clearTimeout(timer); if (slides.length > 1 && !RM) timer = setTimeout(next, dur); }
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-slide-prev],[data-slide-next],[data-slide-seg]');
        if (!btn || !root.contains(btn)) return;
        if (btn.hasAttribute('data-slide-prev')) show(idx - 1);
        else if (btn.hasAttribute('data-slide-next')) show(idx + 1);
        else show(segs.indexOf(btn));
        reset();
      });
      show(0); reset();
      // keep any bundled hero video looping reliably
      var hv = root.querySelector('video[data-hero-video]');
      if (hv && !RM) {
        hv.muted = true; hv.loop = true;
        ['ended', 'pause', 'stalled', 'waiting'].forEach(function (ev) {
          hv.addEventListener(ev, function () { if (hv.ended) hv.currentTime = 0; var p = hv.play(); if (p && p.catch) p.catch(function () {}); });
        });
      }
    });
  }

  /* ==================================================================
     HERO FIT — size the hero so it + the AI strip exactly fill the first
     screen (so the "Virtual Fitting Room" / "Find My XSIVA ID" buttons are
     fully visible above the fold). Desktop only; mobile keeps its stacked
     layout. Sets --hero-h, consumed by .xs-hero and .xs-hero__media.
     ================================================================== */
  function initHeroFit() {
    var hero = $('[data-hero]'); if (!hero) return;
    var strip = $('[data-ai-strip]');
    function apply() {
      var top = hero.getBoundingClientRect().top + window.scrollY; // announcement + header above the hero
      var stripH = strip ? strip.offsetHeight : 0;
      var h = window.innerHeight - top - stripH;
      if (h < 280) h = 280; // floor
      hero.style.setProperty('--hero-h', Math.round(h) + 'px');
    }
    apply();
    var raf;
    window.addEventListener('resize', function () { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(apply); });
    window.addEventListener('load', apply);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply);
    XSIVA._heroFit = apply; // re-run on section reloads
  }

  /* ==================================================================
     CAROUSELS — infinite loop (3× track) + drag momentum (desktop)
     + native momentum (touch). The scroll position is wrapped so the
     content loops seamlessly in both directions.
     ================================================================== */
  var scanCarousels = function () {};
  function initCarousels() {
    var st = { down: false, car: null, sx: 0, sl: 0, moved: 0, vx: 0, lastX: 0, lastT: 0, raf: 0, upAt: 0 };
    var wired = new WeakSet();
    function stop() { if (st.raf) { cancelAnimationFrame(st.raf); st.raf = 0; } }
    function glide() {
      if (!st.car) { st.raf = 0; return; }
      st.vx *= 0.95; st.car.scrollLeft -= st.vx;
      if (Math.abs(st.vx) > 0.15) st.raf = requestAnimationFrame(glide); else st.raf = 0;
    }
    // width of one copy of the item set (track holds 3 copies)
    function copyW(car) {
      if (!car._looped) return 0;
      var cs = car.children, per = Math.round(cs.length / 3);
      if (per > 0 && cs.length >= per + 1) { var w = cs[per].offsetLeft - cs[0].offsetLeft; if (w > 1) return w; }
      return 0;
    }
    // keep the viewport inside the middle copy → seamless wrap
    function wrap(car) {
      var cw = copyW(car); if (!cw) return;
      if (car.scrollLeft < cw) { car.scrollLeft += cw; if (st.down && st.car === car) st.sl += cw; }
      else if (car.scrollLeft >= 2 * cw) { car.scrollLeft -= cw; if (st.down && st.car === car) st.sl -= cw; }
    }
    // clone a carousel item as a purely-decorative duplicate: hidden from AT, out of the
    // tab order (inert + tabindex fallback), and with any id stripped to avoid duplicates.
    function markClone(node) {
      // aria-hidden + tabindex -1 hide clones from AT and the tab order, but they
      // must stay CLICKABLE — `inert` made 2 of the 3 loop copies swallow taps, so
      // cards only worked when the viewport happened to rest on the middle copy.
      node.setAttribute('aria-hidden', 'true');
      if (node.removeAttribute) node.removeAttribute('id');
      $$('[id]', node).forEach(function (n) { n.removeAttribute('id'); });
      $$('a[href], button, input, select, textarea, [tabindex]', node).forEach(function (n) { n.setAttribute('tabindex', '-1'); });
      return node;
    }
    function setupLoop(car) {
      if (car._looped) return;
      var items = Array.prototype.slice.call(car.children);
      if (items.length < 2) return; // nothing to loop
      car._looped = true;
      var before = document.createDocumentFragment(), after = document.createDocumentFragment();
      items.forEach(function (it) { before.appendChild(markClone(it.cloneNode(true))); });
      items.forEach(function (it) { after.appendChild(markClone(it.cloneNode(true))); });
      car.insertBefore(before, car.firstChild);
      car.appendChild(after);
    }
    function ensure(car) {
      if (wired.has(car)) return; wired.add(car);
      // Re-centre into the middle copy only while mouse-dragging or once scrolling has
      // SETTLED — writing scrollLeft during native touch momentum kills the fling on
      // iOS (one swipe would stop dead at the next card instead of gliding on).
      var settle = 0;
      car.addEventListener('scroll', function () {
        if (st.down && st.car === car) { wrap(car); return; }
        clearTimeout(settle);
        settle = setTimeout(function () { wrap(car); }, 160);
      }, { passive: true });
      if (car._looped) {
        var tries = 0;
        var init = function () {
          var cw = copyW(car);
          if (cw && car.scrollWidth > car.clientWidth + 4) { if (car.scrollLeft <= 4) car.scrollLeft = cw; }
          else if (++tries < 120) { requestAnimationFrame(init); }
        };
        requestAnimationFrame(init);
      }
    }
    // idempotent — safe to call again on shopify:section:load
    scanCarousels = function () {
      $$('[data-carousel][data-loop]').forEach(setupLoop);
      $$('[data-carousel]').forEach(ensure);
    };

    // global drag listeners (registered once)
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      var car = e.target.closest && e.target.closest('[data-carousel]');
      if (!car) return;
      ensure(car); stop(); st.down = true; st.car = car; st.sx = e.clientX; st.sl = car.scrollLeft;
      st.moved = 0; st.vx = 0; st.lastX = e.clientX; st.lastT = performance.now();
    });
    document.addEventListener('pointermove', function (e) {
      if (!st.down) return;
      var dx = e.clientX - st.sx; st.moved = Math.max(st.moved, Math.abs(dx));
      st.car.scrollLeft = st.sl - dx;
      var now = performance.now(), dt = now - st.lastT;
      if (dt > 0) st.vx = 0.8 * st.vx + 0.2 * ((e.clientX - st.lastX) / dt * 16);
      st.lastX = e.clientX; st.lastT = now;
    });
    document.addEventListener('pointerup', function () {
      if (st.down) { st.down = false; st.upAt = performance.now(); if (Math.abs(st.vx) > 0.15) { stop(); st.raf = requestAnimationFrame(glide); } }
    });
    // a cancelled pointer never produces a click — clear the drag state fully or a
    // stale st.down keeps scrolling on mouse-move and stale st.moved eats the next click
    document.addEventListener('pointercancel', function () {
      if (st.down) { st.down = false; st.moved = 0; stop(); }
    });
    document.addEventListener('click', function (e) {
      var car = e.target.closest && e.target.closest('[data-carousel]');
      // only swallow the click that DIRECTLY follows a drag — without the time guard,
      // a drag released off-target left st.moved armed and cancelled some later,
      // completely legitimate card click ("cards only occasionally selectable")
      if (car && st.moved > 8 && st.upAt && performance.now() - st.upAt < 450) { e.preventDefault(); e.stopPropagation(); }
      st.moved = 0;
    }, true);
    // stop the browser's native link/image drag from hijacking the carousel drag
    document.addEventListener('dragstart', function (e) {
      if (e.target.closest && e.target.closest('[data-carousel]')) e.preventDefault();
    });

    scanCarousels();
  }

  /* ==================================================================
     PDP GALLERY — grab to scroll the page vertically, with momentum
     ================================================================== */
  function initPdpScroll() {
    var st = { down: false, y0: 0, sy0: 0, moved: 0, vy: 0, lastY: 0, lastT: 0, raf: 0 };
    var se = function () { return document.scrollingElement || document.documentElement; };
    function stop() { if (st.raf) { cancelAnimationFrame(st.raf); st.raf = 0; } }
    function glide() { st.vy *= 0.95; se().scrollTop -= st.vy; if (Math.abs(st.vy) > 0.3) st.raf = requestAnimationFrame(glide); else st.raf = 0; }
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // touch already has native inertial scroll
      if (!(e.target.closest && e.target.closest('.xs-pdp__gallery'))) return;
      stop(); st.down = true; st.y0 = e.clientY; st.sy0 = se().scrollTop; st.moved = 0; st.vy = 0; st.lastY = e.clientY; st.lastT = performance.now();
    }, { passive: true });
    document.addEventListener('pointermove', function (e) {
      if (!st.down) return;
      var dy = e.clientY - st.y0; st.moved = Math.max(st.moved, Math.abs(dy));
      se().scrollTop = st.sy0 - dy;
      var now = performance.now(), d = now - st.lastT; if (d > 0) st.vy = (e.clientY - st.lastY) / d * 16;
      st.lastY = e.clientY; st.lastT = now;
      if (e.cancelable && st.moved > 4) e.preventDefault();
    }, { passive: false });
    document.addEventListener('pointerup', function () {
      if (!st.down) return; st.down = false;
      if (Math.abs(st.vy) > 0.4) { stop(); st.raf = requestAnimationFrame(glide); }
    }, { passive: true });
    document.addEventListener('click', function (e) {
      if (st.moved > 8) { var g = e.target.closest && e.target.closest('.xs-pdp__gallery'); if (g) { e.preventDefault(); e.stopPropagation(); } st.moved = 0; }
    }, true);
  }

  /* ==================================================================
     PRODUCT CARD — front/back image swap (arrows + swipe)
     ================================================================== */
  function cardGo(card, dir) {
    var imgs = $$('img', card.querySelector('.xs-card__media') || card);
    if (imgs.length < 2) return;
    var cur = imgs.findIndex(function (i) { return !i.classList.contains('is-hidden'); });
    if (cur < 0) cur = 0;
    var nxt = (cur + dir + imgs.length) % imgs.length;
    imgs.forEach(function (i, k) { i.classList.toggle('is-hidden', k !== nxt); });
  }
  on('click', '.xs-card__arrow', function (e, el) {
    e.preventDefault(); e.stopPropagation();
    cardGo(el.closest('.xs-card'), el.classList.contains('xs-card__arrow--next') ? 1 : -1);
  });
  function initCardSwipe() {
    var s = { down: false, el: null, sx: 0, sy: 0, dx: 0, horiz: false, swiped: false };
    document.addEventListener('pointerdown', function (e) {
      var media = e.target.closest && e.target.closest('.xs-card__media');
      if (!media || media.closest('[data-carousel]')) return; // carousels handle their own drag
      if (media.querySelectorAll('img').length < 2) return;
      s.down = true; s.el = media; s.sx = e.clientX; s.sy = e.clientY; s.dx = 0; s.horiz = false;
    }, { passive: true });
    document.addEventListener('pointermove', function (e) {
      if (!s.down) return;
      var dx = e.clientX - s.sx, dy = e.clientY - s.sy;
      if (!s.horiz) { if (Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) s.horiz = true; else if (Math.abs(dy) > 10) { s.down = false; return; } }
      if (s.horiz) { s.dx = dx; if (e.cancelable) e.preventDefault(); }
    }, { passive: false });
    document.addEventListener('pointerup', function () {
      if (!s.down) return; s.down = false;
      if (s.horiz && Math.abs(s.dx) > 40) { cardGo(s.el.closest('.xs-card'), s.dx < 0 ? 1 : -1); s.swiped = true; }
      s.el = null;
    }, { passive: true });
    document.addEventListener('click', function (e) {
      if (s.swiped) { var m = e.target.closest && e.target.closest('.xs-card__media'); if (m) { e.preventDefault(); e.stopPropagation(); } s.swiped = false; }
    }, true);
  }

  /* ==================================================================
     XSIVA ID DROPDOWN (category strip)
     ================================================================== */
  on('click', '[data-id-menu-toggle]', function (e, el) {
    e.preventDefault();
    var menu = $('[data-id-menu]'); var scrim = $('[data-id-menu-scrim]');
    if (!menu) return;
    var open = menu.hasAttribute('hidden');
    if (open) {
      var r = el.getBoundingClientRect(), W = 160;
      var left = Math.min(Math.max(12, r.left), Math.max(12, (window.innerWidth || 360) - W - 12));
      menu.style.left = Math.round(left) + 'px';
      menu.style.top = Math.round(r.bottom + 6) + 'px';
      menu.removeAttribute('hidden'); if (scrim) scrim.removeAttribute('hidden');
    } else { menu.setAttribute('hidden', ''); if (scrim) scrim.setAttribute('hidden', ''); }
    el.setAttribute('aria-expanded', String(open));
  });
  on('click', '[data-id-menu-scrim]', function () {
    var menu = $('[data-id-menu]'); var scrim = $('[data-id-menu-scrim]');
    if (menu) menu.setAttribute('hidden', ''); if (scrim) scrim.setAttribute('hidden', '');
    var t = $('[data-id-menu-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
  });

  /* ==================================================================
     PLP FACET DROPDOWNS (native filter form)
     ================================================================== */
  on('click', '[data-facet-btn]', function (e, el) {
    e.preventDefault();
    var menu = el.parentNode.querySelector('[data-facet-menu]');
    $$('[data-facet-btn]').forEach(function (b) { if (b !== el) b.setAttribute('aria-expanded', 'false'); });
    $$('[data-facet-menu]').forEach(function (m) { if (m !== menu) m.setAttribute('hidden', ''); });
    if (menu) { menu.toggleAttribute('hidden'); el.setAttribute('aria-expanded', String(!menu.hasAttribute('hidden'))); }
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.xs-facet')) { $$('[data-facet-menu]').forEach(function (m) { m.setAttribute('hidden', ''); }); $$('[data-facet-btn]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
  });
  // AJAX filtering — apply filters without a full page reload, so several can be
  // ticked in a row and the filter menus stay open. Fetches the FULL filtered page
  // (reliable — always contains the grid) and swaps only the product grid + count,
  // leaving the filter bar intact. Hard-navigates if the response can't be parsed
  // or the request errors, so filtering ALWAYS applies even if the swap fails.
  // Reflect the current checkbox/price state on the filter bar (black highlight on
  // selected values + active facet buttons) — the bar isn't re-rendered on AJAX.
  function xsSyncFilterUI(form) {
    Array.prototype.forEach.call(form.querySelectorAll('.xs-facet'), function (facet) {
      var active = 0;
      Array.prototype.forEach.call(facet.querySelectorAll('.xs-facet__menu label'), function (label) {
        var cb = label.querySelector('input[type="checkbox"]');
        if (cb) { label.classList.toggle('is-active', cb.checked); if (cb.checked) active++; }
      });
      Array.prototype.forEach.call(facet.querySelectorAll('input[type="number"]'), function (inp) { if (inp.value) active++; });
      var btn = facet.querySelector('[data-facet-btn]');
      if (btn) btn.classList.toggle('is-active', active > 0);
    });
  }
  var xsFilterCtrl;
  function xsApplyFilters(form) {
    xsSyncFilterUI(form);
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '' && v != null) params.append(k, v); });
    var qs = params.toString();
    var url = location.pathname + (qs ? '?' + qs : '');
    // Clear button: shown whenever any filter is active (the bar isn't re-rendered on AJAX).
    var clearBtn = document.querySelector('[data-clear-filters]');
    if (clearBtn) {
      var anyActive = !!form.querySelector('input[type="checkbox"]:checked');
      var nums = form.querySelectorAll('input[type="number"]');
      for (var n = 0; n < nums.length; n++) { if (nums[n].value) anyActive = true; }
      if (anyActive) { clearBtn.removeAttribute('hidden'); } else { clearBtn.setAttribute('hidden', ''); }
    }
    var cur = document.querySelector('[data-collection-grid]');
    if (cur) cur.setAttribute('aria-busy', 'true');
    if (xsFilterCtrl) xsFilterCtrl.abort();
    xsFilterCtrl = new AbortController();
    fetch(url, { signal: xsFilterCtrl.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.querySelector('[data-collection-grid]');
        var cg = document.querySelector('[data-collection-grid]');
        if (!ng || !cg) { window.location.assign(url); return; }   // couldn't parse — hard nav so the filter still applies
        cg.innerHTML = ng.innerHTML;
        cg.removeAttribute('aria-busy');
        var nc = doc.querySelector('[data-collection-count]');
        var cc = document.querySelector('[data-collection-count]');
        if (nc && cc) cc.innerHTML = nc.innerHTML;
        history.pushState({ xsFilter: true }, '', url);
      })
      .catch(function (err) { if (err.name !== 'AbortError') window.location.assign(url); });
  }
  on('change', '[data-filter-form]', function (e, form) { xsApplyFilters(form); });
  // mobile: facets collapse behind a Filter toggle (CSS shows the button ≤680px)
  on('click', '[data-filters-toggle]', function (e, el) {
    e.preventDefault();
    var form = el.closest('.xs-plp-bar'); if (!form) return;
    var open = form.classList.toggle('is-filters-open');
    el.setAttribute('aria-expanded', String(open));
  });
  on('submit', '[data-filter-form]', function (e, form) { e.preventDefault(); xsApplyFilters(form); });
  window.addEventListener('popstate', function () { location.reload(); });

  /* ==================================================================
     PDP — accordions (colour/size handled by the inline [data-opt] script)
     ================================================================== */
  on('click', '[data-acc-toggle]', function (e, el) {
    e.preventDefault();
    var body = el.nextElementSibling;
    var open = body && !body.hasAttribute('hidden');
    if (body) body.toggleAttribute('hidden');
    var sign = el.querySelector('.xs-acc__sign'); if (sign) sign.textContent = open ? '+' : '−';
    el.setAttribute('aria-expanded', String(!open));
  });

  /* ==================================================================
     AJAX CART + DRAWER
     ================================================================== */
  function fetchConfig(type) {
    return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
  }
  // resolve an add-to-cart response, throwing Shopify's {description} on a non-2xx so callers can surface it
  function addResult(r) { return r.json().then(function (d) { if (!r.ok) { throw d; } return d; }); }
  function refreshCartUI() {
    // remember which cart-line control had focus so we can restore it after the re-render
    var active = document.activeElement;
    var fAttr = active && active.hasAttribute ? (active.hasAttribute('data-line-inc') ? 'inc' : active.hasAttribute('data-line-dec') ? 'dec' : active.hasAttribute('data-line-remove') ? 'remove' : null) : null;
    var fKey = fAttr ? active.getAttribute('data-key') : null;
    return fetch(ROOT + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var html = data['cart-drawer']; if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-drawer]');
        var live = $('[data-cart-drawer]');
        if (fresh && live) {
          live.innerHTML = fresh.innerHTML;
          if (fAttr && fKey) {
            var restore = live.querySelector('[data-line-' + fAttr + '][data-key="' + fKey + '"]');
            if (restore) { try { restore.focus(); } catch (e) {} }
          }
        }
      })
      .then(updateCartCount)
      .catch(function () {});
  }
  function updateCartCount() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        $$('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
        return cart;
      })
      .catch(function () {});
  }
  XSIVA.addToCart = function (idOrForm) {
    var body;
    if (typeof idOrForm === 'string' || typeof idOrForm === 'number') body = JSON.stringify({ items: [{ id: idOrForm, quantity: 1 }] });
    else body = JSON.stringify({ items: [{ id: idOrForm.id, quantity: idOrForm.quantity || 1 }] });
    return fetch(ROOT + 'cart/add.js', Object.assign(fetchConfig(), { body: body }))
      .then(addResult)
      .then(function () { return refreshCartUI(); })
      .then(function () { openOverlay($('[data-cart]')); })
      .catch(function (err) { showToast((err && err.description) || (XSIVA.strings && XSIVA.strings.add_error) || 'Could not add to bag', true); });
  };
  // add-to-cart from any product form / card
  on('submit', 'form[data-cart-add]', function (e, form) {
    e.preventDefault();
    var fd = new FormData(form);
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(addResult)
      .then(function () { return refreshCartUI(); })
      .then(function () { openOverlay($('[data-cart]')); })
      .catch(function (err) { showToast((err && err.description) || (XSIVA.strings && XSIVA.strings.add_error) || 'Could not add to bag', true); });
  });
  // catalogue quick-add: + Bag opens a size popup; tapping a size adds that variant.
  // No size is ever defaulted — every add is an explicit size choice.
  function closeQadds(except) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-qadd-panel].is-open'), function (p) {
      if (p === except) return;
      p.classList.remove('is-open');
      var b = p.parentNode.querySelector('[data-qadd]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  on('click', '[data-qadd]', function (e, el) {
    e.preventDefault();
    var panel = el.parentNode.querySelector('[data-qadd-panel]'); if (!panel) return;
    var opening = !panel.classList.contains('is-open');
    closeQadds(opening ? panel : null);
    panel.classList.toggle('is-open', opening);
    el.setAttribute('aria-expanded', String(opening));
  });
  on('click', '[data-qadd-size]', function (e, el) {
    if (el.disabled) return;
    var vid = el.dataset.vid; if (!vid) return;
    closeQadds();
    XSIVA.addToCart(vid);
  });
  on('click', '[data-qadd-close]', function (e) { e.preventDefault(); closeQadds(); });
  // multi-colour products: picking a swatch remaps every size chip to that colour's
  // variant (id + availability) from the data-sp-map JSON the picker emitted.
  function spRemap(scope, colorVal) {
    var mapEl = scope.querySelector('[data-sp-map]'); if (!mapEl) return;
    var map = [];
    try { map = JSON.parse(mapEl.textContent); } catch (err) { return; }
    Array.prototype.forEach.call(scope.querySelectorAll('[data-qadd-size], [data-lk-size]'), function (chip) {
      var s = chip.dataset.size || chip.textContent.trim();
      var m = null;
      for (var i = 0; i < map.length; i++) { if (map[i].c === colorVal && map[i].s === s) { m = map[i]; break; } }
      if (m && m.a) {
        chip.disabled = false; chip.classList.remove('is-unavail'); chip.removeAttribute('aria-disabled');
        chip.dataset.vid = m.id;
      } else {
        chip.disabled = true; chip.classList.add('is-unavail'); chip.setAttribute('aria-disabled', 'true');
        delete chip.dataset.vid;
        chip.classList.remove('is-active'); chip.setAttribute('aria-pressed', 'false');
      }
    });
  }
  on('click', '[data-qadd-color], [data-lk-color]', function (e, el) {
    var scope = el.closest('[data-qadd-panel]') || el.closest('[data-lookp]'); if (!scope) return;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-qadd-color], [data-lk-color]'), function (b) {
      b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false');
    });
    el.classList.add('is-active'); el.setAttribute('aria-pressed', 'true');
    spRemap(scope, el.dataset.value);
    // look rail: keep the hidden input honest — the picked size may not exist in the new colour
    var lkInput = scope.querySelector('[data-lk-id]');
    if (lkInput) {
      var act = scope.querySelector('[data-lk-size].is-active');
      var btn = scope.querySelector('[data-lk-add]');
      if (act && act.dataset.vid) { lkInput.value = act.dataset.vid; if (btn) btn.disabled = false; }
      else { lkInput.value = ''; if (btn) btn.disabled = true; }
    }
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-qadd-wrap]')) closeQadds(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQadds(); });

  // shop-the-look rail: size chip picks the variant, arms the row's add button
  on('click', '[data-lk-size]', function (e, el) {
    var wrap = el.closest('[data-lookp]'); if (!wrap || el.disabled) return;
    Array.prototype.forEach.call(wrap.querySelectorAll('[data-lk-size]'), function (b) {
      b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false');
    });
    el.classList.add('is-active'); el.setAttribute('aria-pressed', 'true');
    var inp = wrap.querySelector('[data-lk-id]'); if (inp) inp.value = el.dataset.vid;
    var btn = wrap.querySelector('[data-lk-add]'); if (btn) btn.disabled = false;
  });
  on('click', '[data-cart-open]', function (e) { e.preventDefault(); openOverlay($('[data-cart]')); refreshCartUI(); });
  on('click', '[data-cart-close]', function () { closeOverlay($('[data-cart]')); });
  // qty +/- and remove inside the drawer (delegated, survives re-render)
  function changeLine(key, qty) {
    return fetch(ROOT + 'cart/change.js', Object.assign(fetchConfig(), { body: JSON.stringify({ id: key, quantity: qty }) }))
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        return refreshCartUI();
      });
  }
  on('click', '[data-line-dec]', function (e, el) { e.preventDefault(); changeLine(el.dataset.key, parseInt(el.dataset.qty, 10) - 1); });
  on('click', '[data-line-inc]', function (e, el) { e.preventDefault(); changeLine(el.dataset.key, parseInt(el.dataset.qty, 10) + 1); });
  on('click', '[data-line-remove]', function (e, el) { e.preventDefault(); changeLine(el.dataset.key, 0); });

  /* ==================================================================
     PREDICTIVE SEARCH (header live dropdown)
     ================================================================== */
  function initSearch() {
    var wrap = $('[data-search]'); if (!wrap) return;
    var input = $('input', wrap);
    var panel = $('[data-search-results]', wrap);
    var clear = $('[data-search-clear]', wrap);
    var t;
    function hide() { if (panel) panel.setAttribute('hidden', ''); if (clear) clear.setAttribute('hidden', ''); if (input) input.setAttribute('aria-expanded', 'false'); }
    function run(q) {
      if (!q) { hide(); return; }
      if (clear) clear.removeAttribute('hidden');
      // Full storefront search (not /search/suggest) so the preview honours Search &
      // Discovery synonyms + prefix matching, matching the results page. Server-rendered
      // section: titles escaped + prices money-formatted by Liquid (no client HTML build).
      // _v busts Shopify's per-edge CDN cache of section responses — bump it whenever
      // predictive-search.liquid's markup changes, or stale edges serve the old render.
      fetch(ROOT + 'search?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last&section_id=predictive-search&_v=3', { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!panel) return;
          panel.innerHTML = (html && html.trim()) ? html : '<div class="xs-search-empty">' + ((window.XSIVA && XSIVA.strings && XSIVA.strings.no_results) || 'No results') + '</div>';
          panel.removeAttribute('hidden');
          if (input) input.setAttribute('aria-expanded', 'true');
        })
        .catch(function () {});
    }
    if (input) input.addEventListener('input', function () { clearTimeout(t); var q = input.value.trim(); t = setTimeout(function () { run(q); }, 200); });
    if (clear) clear.addEventListener('click', function () { input.value = ''; hide(); input.focus(); });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-search]')) hide(); });
  }

  /* ==================================================================
     WISHLIST (localStorage — no native Shopify equivalent)
     ================================================================== */
  var WK = 'xsiva:wishlist';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WK) || '[]'); } catch (e) { return []; } }
  function wishSet(v) { try { localStorage.setItem(WK, JSON.stringify(v)); } catch (e) {} }
  XSIVA.wishlist = { get: function () { return wishGet().map(function (x) { return x.handle; }); } };
  function wishHas(handle) { return wishGet().some(function (x) { return x.handle === handle; }); }
  function syncWishUI() {
    var items = wishGet();
    $$('[data-wish]').forEach(function (b) { b.classList.toggle('is-wished', wishHas(b.dataset.wish)); });
    $$('[data-wish-count]').forEach(function (n) { n.textContent = items.length; });
    renderWishlistPage();
  }
  on('click', '[data-wish]', function (e, el) {
    e.preventDefault(); e.stopPropagation();
    var handle = el.dataset.wish; var list = wishGet(); var i = list.findIndex(function (x) { return x.handle === handle; });
    if (i >= 0) list.splice(i, 1);
    else list.push({ handle: handle, title: el.dataset.title || '', price: el.dataset.price || '', url: el.dataset.url || '#', image: el.dataset.image || '' });
    wishSet(list); syncWishUI();
  });
  // wishlist "+ Bag" — add the product's first available variant to cart
  on('click', '[data-wish-bag]', function (e, el) {
    e.preventDefault();
    var handle = el.getAttribute('data-wish-bag'); if (!handle) return;
    fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var v = null; for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
        if (!v) { showToast((XSIVA.strings && XSIVA.strings.sold_out) || 'Sold out', true); return; }
        return XSIVA.addToCart(v.id);
      })
      .catch(function () {});
  });
  function renderWishlistPage() {
    var grid = $('[data-wishlist-grid]'); if (!grid) return;
    var empty = $('[data-wishlist-empty]');
    var items = wishGet();
    grid.textContent = '';
    if (!items.length) { if (empty) empty.removeAttribute('hidden'); return; }
    if (empty) empty.setAttribute('hidden', '');
    // Built with DOM APIs + textContent so a product title containing markup can never inject HTML.
    var bagLabel = grid.getAttribute('data-label-bag') || '+ Bag';
    var removeLabel = grid.getAttribute('data-label-remove') || '✕ Remove';
    items.forEach(function (p) {
      var card = document.createElement('div'); card.className = 'xs-card';
      var media = document.createElement('a'); media.className = 'xs-card__media'; media.href = p.url || '#';
      if (p.image) media.style.backgroundImage = 'url(' + JSON.stringify(String(p.image)) + ')';
      card.appendChild(media);
      var row = document.createElement('div'); row.className = 'xs-card__row';
      var name = document.createElement('span'); name.className = 'xs-card__name'; name.textContent = p.title || '';
      var price = document.createElement('span'); price.className = 'xs-card__price'; price.textContent = p.price || '';
      row.appendChild(name); row.appendChild(price); card.appendChild(row);
      var bag = document.createElement('a'); bag.className = 'xs-card__add'; bag.href = p.url || '#';
      bag.setAttribute('data-wish-bag', p.handle || '');
      bag.style.cssText = 'margin-top:9px;text-align:center;display:block'; bag.textContent = bagLabel;
      card.appendChild(bag);
      var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'xs-card__add is-wished';
      rm.setAttribute('data-wish', p.handle || '');
      rm.style.cssText = 'margin-top:8px;background:var(--xs-ink);color:#fff'; rm.textContent = removeLabel;
      card.appendChild(rm);
      grid.appendChild(card);
    });
  }


  /* ==================================================================
     PDP GALLERY: desktop drag-to-scroll with snap between shots
     (the gallery ships a grab cursor — this makes it real; mouse only,
     touch keeps native scrolling)
     ================================================================== */
  function initPdpGalleryDrag() {
    var gal = $('.xs-pdp__gallery'); if (!gal) return;
    var shots = $$('.xs-pdp__shot', gal);
    var st = { on: false, id: null, lastY: 0, total: 0, startIdx: 0 };
    function offsetTop() { var h = $('.xs-header'); return (h ? h.offsetHeight : 0) + 10; }
    function nearestIdx() {
      var off = offsetTop(), best = 0, bd = 1e9;
      shots.forEach(function (s, i) {
        var d = Math.abs(s.getBoundingClientRect().top - off);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    function snapTo(i) {
      i = Math.max(0, Math.min(shots.length - 1, i));
      var top = shots[i].getBoundingClientRect().top + window.scrollY - offsetTop();
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
    gal.addEventListener('dragstart', function (e) { e.preventDefault(); });
    gal.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      st.on = true; st.id = e.pointerId; st.lastY = e.clientY; st.total = 0; st.startIdx = nearestIdx();
      try { gal.setPointerCapture(e.pointerId); } catch (err) {}
    });
    gal.addEventListener('pointermove', function (e) {
      if (!st.on || e.pointerId !== st.id) return;
      var dy = e.clientY - st.lastY; st.lastY = e.clientY; st.total += dy;
      if (dy) window.scrollBy(0, -dy);
      e.preventDefault();
    });
    function end(e) {
      if (!st.on || (e.pointerId !== undefined && e.pointerId !== st.id)) return;
      st.on = false;
      try { gal.releasePointerCapture(st.id); } catch (err) {}
      if (shots.length < 2) return;
      if (st.total <= -60) snapTo(st.startIdx + 1);
      else if (st.total >= 60) snapTo(st.startIdx - 1);
      else if (Math.abs(st.total) > 5) snapTo(st.startIdx);
    }
    gal.addEventListener('pointerup', end);
    gal.addEventListener('pointercancel', end);
  }

  /* ==================================================================
     FITTING ROOM — opens the Genlook virtual try-on (window.Genlook.cabin).
     The widget needs product-page context: on a PDP it opens in place; from
     anywhere else we route to the featured garment's PDP with ?xsfit=1,
     which auto-opens the cabin on arrival.
     ================================================================== */
  XSIVA.fittingRoomProvider = null; // custom launcher override (kept for future apps)
  function genlookOpen() {
    var g = window.Genlook;
    if (g && g.cabin && typeof g.cabin.open === 'function') { g.cabin.open(); return true; }
    return false;
  }
  function genlookAttempt(maxTries) {
    var tries = 0;
    (function poll() {
      if (genlookOpen()) return;
      if (++tries < maxTries) setTimeout(poll, 400);
      else showToast(window.XSIVA.strings && XSIVA.strings.fitUnavailable || 'The fitting room is unavailable right now.');
    })();
  }
  XSIVA.openFittingRoom = function (productHandle) {
    if (typeof XSIVA.fittingRoomProvider === 'function') return XSIVA.fittingRoomProvider(productHandle);
    if ($('.xs-pdp')) { genlookAttempt(25); return; }
    if (productHandle) { window.location.href = ROOT + 'products/' + productHandle + '?xsfit=1'; return; }
    showToast(window.XSIVA.strings && XSIVA.strings.fitUnavailable || 'The fitting room is unavailable right now.');
  };
  on('click', '[data-fit-open]', function (e, el) { e.preventDefault(); XSIVA.openFittingRoom(el.dataset.handle || null); });
  function initFitAutoOpen() {
    if (/[?&]xsfit=1/.test(window.location.search) && $('.xs-pdp')) genlookAttempt(40);
  }

  /* ==================================================================
     MOBILE STICKY BUY BAR (PDP) — mirrors the real add button's label and
     disabled state, proxies clicks to it, and shows whenever the buy box
     is off-screen. Pure enhancement: without JS the bar simply stays hidden.
     ================================================================== */
  function initPdpBuyBar() {
    var bar = $('[data-buybar]'); if (!bar) return;
    var real = $('[data-add-btn]');
    var buy = real && real.closest('.xs-pdp__buy');
    if (!real || !buy) return;
    var btn = $('[data-buybar-add]', bar);
    function sync() {
      btn.disabled = real.disabled;
      var label = real.textContent.trim();
      if (label) btn.textContent = label;
    }
    sync();
    new MutationObserver(sync).observe(real, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    btn.addEventListener('click', function () { real.click(); });
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var off = !entries[0].isIntersecting;
      bar.classList.toggle('is-on', off);
      bar.setAttribute('aria-hidden', String(!off));
      document.body.classList.toggle('xs-buybar-on', off);
    }, { rootMargin: '-70px 0px 0px 0px' }).observe(buy);
  }

  /* ==================================================================
     CHAT — opens the store's Shopify Inbox AI agent (<shopify-chat>).
     `open` is an attribute/property on the element; show() is the method.
     ================================================================== */
  XSIVA.chatProvider = null;
  function openInboxChat(el) {
    if (typeof el.show === 'function') el.show();
    else el.setAttribute('open', '');
  }
  XSIVA.openChat = function () {
    if (typeof XSIVA.chatProvider === 'function') return XSIVA.chatProvider();
    var el = document.querySelector('shopify-chat');
    if (el) { openInboxChat(el); return; }
    // widget script not loaded yet — wait for it, then open
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('shopify-chat').then(function () {
        var c = document.querySelector('shopify-chat');
        if (c) openInboxChat(c);
      });
      showToast(window.XSIVA.strings && XSIVA.strings.chatLoading || 'One moment — opening chat…');
    }
  };
  on('click', '[data-chat-open]', function (e) { e.preventDefault(); XSIVA.openChat(); });

  /* ==================================================================
     GLOBAL: language cycle (cosmetic), esc to close
     ================================================================== */
  var LANGS = ['EN', 'FR', 'ES', 'IT', 'DE', 'RU', 'PT'];
  // account-settings inline cycle (kept for the Settings tab toggle)
  on('click', '[data-lang]', function (e, el) {
    e.preventDefault();
    var cur = el.dataset.langCur || el.textContent.trim().split(' ')[0];
    var i = LANGS.indexOf(cur); var next = LANGS[(i + 1) % LANGS.length];
    el.dataset.langCur = next;
    $$('[data-lang-label]').forEach(function (n) { n.textContent = next; });
  });
  // header language dropdown (styled like the other dropdowns)
  on('click', '[data-lang-toggle]', function (e, el) {
    e.preventDefault();
    var menu = $('[data-lang-menu]'); if (menu) { menu.toggleAttribute('hidden'); el.setAttribute('aria-expanded', String(!menu.hasAttribute('hidden'))); }
  });
  on('click', '[data-lang-pick]', function (e, el) {
    e.preventDefault();
    $$('[data-lang-label]').forEach(function (n) { n.textContent = el.dataset.langPick; });
    var menu = $('[data-lang-menu]');
    if (menu) {
      $$('[data-lang-pick]', menu).forEach(function (b) { b.classList.remove('is-active'); });
      el.classList.add('is-active');
      menu.setAttribute('hidden', '');
    }
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.xs-lang')) { var m = $('[data-lang-menu]'); if (m) m.setAttribute('hidden', ''); var lt = $('[data-lang-toggle]'); if (lt) lt.setAttribute('aria-expanded', 'false'); }
  });
  // mobile: magnifier toggles a full-width search row
  on('click', '[data-search-toggle]', function (e, el) {
    e.preventDefault();
    var h = $('.xs-header'); if (!h) return;
    var open = h.classList.toggle('is-search-open');
    el.setAttribute('aria-expanded', String(open));
    if (open) { var inp = $('[data-search] input', h); if (inp) inp.focus(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.xs-overlay.is-open, .xs-fit.is-open').forEach(closeOverlay);
    var h = $('.xs-header.is-search-open'); if (h) h.classList.remove('is-search-open');
  });
  // trap Tab focus inside an open overlay/dialog
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var open = $('.xs-overlay.is-open, .xs-fit.is-open');
    if (!open) return;
    var f = focusables(open);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (!open.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  // close on scrim click
  on('click', '[data-overlay-scrim]', function (e, el) { closeOverlay(el.closest('.xs-overlay')); });

  /* ==================================================================
     ACCOUNT TABS (single classic-account page, hash-driven)
     ================================================================== */
  function initAccountTabs() {
    var tabs = $$('[data-acct-tab]'); if (!tabs.length) return;
    // ARIA tab semantics on the nav tablist + panels (wired here to avoid markup churn)
    var navTabs = $$('.xs-acct-tabs [data-acct-tab]');
    var nav = $('.xs-acct-tabs'); if (nav) nav.setAttribute('role', 'tablist');
    navTabs.forEach(function (t) { var k = t.dataset.acctTab; t.setAttribute('role', 'tab'); t.id = 'tab-' + k; t.setAttribute('aria-controls', 'panel-' + k); t.setAttribute('aria-selected', 'false'); });
    $$('[data-acct-panel]').forEach(function (p) { var k = p.dataset.acctPanel; p.setAttribute('role', 'tabpanel'); p.id = 'panel-' + k; p.setAttribute('aria-labelledby', 'tab-' + k); p.setAttribute('tabindex', '0'); });
    function activate(key) {
      var found = false;
      $$('[data-acct-panel]').forEach(function (p) { var on = p.dataset.acctPanel === key; p.hidden = !on; if (on) found = true; });
      if (!found) { key = 'overview'; $$('[data-acct-panel]').forEach(function (p) { p.hidden = p.dataset.acctPanel !== 'overview'; }); }
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.acctTab === key); });
      navTabs.forEach(function (t) { t.setAttribute('aria-selected', String(t.dataset.acctTab === key)); });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); history.replaceState(null, '', '#' + t.dataset.acctTab); activate(t.dataset.acctTab); });
    });
    window.addEventListener('hashchange', function () { activate((location.hash || '#overview').slice(1)); });
    activate((location.hash || '#overview').slice(1));
  }

  // Publish the sticky header's real height as --xs-header-h. Sticky offsets that
  // must clear the header (look rail, PDP info) read it — a hardcoded top:96px sat
  // UNDER the ~140px header at wide viewports, so pinned content was occluded by
  // the translucent header bar (geometrically "pinned", visually hidden).
  function trackHeaderHeight() {
    var h = $('.xs-header'); if (!h) return;
    var set = function () { document.documentElement.style.setProperty('--xs-header-h', h.offsetHeight + 'px'); };
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(h);
    else window.addEventListener('resize', set);
  }

  // Defensive: app embeds / browser extensions injecting body{overflow-x:hidden}
  // silently kill every position:sticky on the page (header, look rail). clip
  // contains horizontal overflow WITHOUT creating a scroll container, so re-assert
  // it (inline + !important outranks any stylesheet) if anything overrode the theme.
  function guardOverflowClip() {
    if (!(window.CSS && CSS.supports && CSS.supports('overflow-x', 'clip'))) return;
    [document.documentElement, document.body].forEach(function (el) {
      var v = getComputedStyle(el).overflowX;
      if (v === 'hidden' || v === 'auto' || v === 'scroll') el.style.setProperty('overflow-x', 'clip', 'important');
    });
  }

  /* -------------------------------------------------- boot */
  function boot() {
    if (RM) $$('video[autoplay]').forEach(function (v) { try { v.autoplay = false; v.pause(); } catch (e) {} });
    trackHeaderHeight();
    guardOverflowClip(); setTimeout(guardOverflowClip, 2000); setTimeout(guardOverflowClip, 6000);
    initAccountTabs();
    initSlideshows();
    initHeroFit();
    initCarousels();
    initPdpScroll();
    initCardSwipe();
    initPdpGalleryDrag();
    initFitAutoOpen();
    initPdpBuyBar();
    initSearch();
    syncWishUI();
    updateCartCount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // re-run light init after Shopify theme-editor section loads
  document.addEventListener('shopify:section:load', function () { initSlideshows(); scanCarousels(); syncWishUI(); if (XSIVA._heroFit) XSIVA._heroFit(); });
})();
